import { render, staticRenderFns } from "./StudyPlanFormationArea.vue?vue&type=template&id=523f4493&scoped=true"
import script from "./StudyPlanFormationArea.vue?vue&type=script&lang=js"
export * from "./StudyPlanFormationArea.vue?vue&type=script&lang=js"
import style0 from "./StudyPlanFormationArea.vue?vue&type=style&index=0&id=523f4493&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523f4493",
  null
  
)

export default component.exports